import { createRouter, createWebHashHistory } from "vue-router"

const routes = [
    {
        path: '',
        redirect:'/avery_media'
    },
    {
        path: '/avery_media',
        name: 'avery_media',
        component: () => import('../pages/averyMedia/index.vue')
    },
    {
        path: '/trade_union',
        name: 'trade_union',
        component: () => import('../pages/tradeUnion/index.vue')
    },
    {
        path: '/about_us',
        name: 'about_us',
        component: () => import('../pages/aboutUs/index.vue')
    },
    {
        path: '/contact_us',
        name: 'contact_us',
        component: () => import('../pages/contactUs/index.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        redirect:'/avery_media'
    }
]

export const router = createRouter({
    history: createWebHashHistory(),
    routes: routes
})

export default router